import { useState } from "react";

export function useTableDialogs() {
  const [newTask, setNewTask] = useState(false);
  const [disqualify, setDisqualify] = useState(false);
  const [shared, setShared] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [sharedMultiple, setSharedMultiple] = useState(false);
  const [transferMultiple, setTransferMultiple] = useState(false);
  const [transferMultipleAdmin, setTransferMultipleAdmin] = useState(false);
  const [compartilharMultipleAdmin, setCompartilharMultipleAdmin] =
    useState(false);
  const [historic, setHistoric] = useState(false);
  const [openAtualizarModal, setOpenAtualizarModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState("");
  const [concludeTask, setConcludeTask] = useState(false);
  const [itemConclude, setItemConclude] = useState<any>({});
  const [tagsOpen, setTagsOpen] = useState(false);
  const [tagsMultipleOpen, setTagsMultipleOpen] = useState(false);
  const [produtosMultipleOpen, setProdutosMultipleOpen] = useState(false);
  const [etapasOpen, setEtapasOpen] = useState(false);
  const [produtosOpen, setProdutosOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [openObservacoesModal, setOpenObservacoesModal] = useState(false);
  const [whatsAppOpen, setWhatsAppOpen] = useState(false);
  const [whatsAppMassOpen, setWhatsAppMassOpen] = useState(false);
  const [whatsAppLead, setWhatsAppLead] = useState<{
    nome: string;
    telefone: string;
    idLeadCorretor: string;
    fotoUrl?: string;
  } | null>(null);

  return {
    newTask,
    setNewTask,
    disqualify,
    setDisqualify,
    shared,
    setShared,
    transfer,
    setTransfer,
    sharedMultiple,
    setSharedMultiple,
    transferMultiple,
    setTransferMultiple,
    transferMultipleAdmin,
    setTransferMultipleAdmin,
    compartilharMultipleAdmin,
    setCompartilharMultipleAdmin,
    historic,
    setHistoric,
    openAtualizarModal,
    setOpenAtualizarModal,
    selectedLeadId,
    setSelectedLeadId,
    concludeTask,
    setConcludeTask,
    itemConclude,
    setItemConclude,
    tagsOpen,
    setTagsOpen,
    tagsMultipleOpen,
    setTagsMultipleOpen,
    produtosMultipleOpen,
    setProdutosMultipleOpen,
    etapasOpen,
    setEtapasOpen,
    produtosOpen,
    setProdutosOpen,
    filtersOpen,
    setFiltersOpen,
    openObservacoesModal,
    setOpenObservacoesModal,
    whatsAppOpen,
    setWhatsAppOpen,
    whatsAppMassOpen,
    setWhatsAppMassOpen,
    whatsAppLead,
    setWhatsAppLead,
  };
}
